import { XIcon } from "@heroicons/react/outline";
import React, { useState } from "react";

import MenuLinkList from "@/components/organisms/mypage/MenuLinkList";
import { mypageMenus } from "@/models/mypage/mypage";

type Props = {
  pageTitle: string;
};

const Header = ({ pageTitle }: Props) => {
  const [openMenu, setOpenMenu] = useState(false);

  const menuFunction = () => {
    setOpenMenu(!openMenu);
  };

  return (
    <>
      {openMenu ? (
        <>
          <aside className="fixed top-0 left-0 z-30 w-[212px] h-screen bg-[#CECECE]">
            <div className="py-10 px-4 bg-white">
              <button
                className="absolute top-0 right-0 p-3"
                onClick={menuFunction}
              >
                <XIcon className="w-5 h-5 text-[#4B4B4B]"></XIcon>
              </button>
              <h2 className="text-xl font-bold">{pageTitle}</h2>
            </div>
            <div className="py-6 px-2">
              <MenuLinkList menus={mypageMenus} />
            </div>
          </aside>
          <div
            className="fixed top-0 left-0 z-20 w-screen h-screen bg-black/50"
            onClick={menuFunction}
          ></div>
        </>
      ) : undefined}

      <header className="flex justify-between items-center p-2 min-h-[50px] bg-white shadow">
        <button onClick={menuFunction} className="block md:hidden">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 cursor-pointer"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <a href="#" className="block md:hidden">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
          </svg>
        </a>
      </header>
    </>
  );
};

export default Header;
